module.exports = __webpack_public_path__ + "static/premium_wyjatkowe_zew-dd5121ae6849ab7408e32362de6ed1a1.png";